import React, { useEffect, useContext, useState, useRef } from 'react'

import { Box, } from '@material-ui/core'

import CustomRadialLinearScale from "./CustomRadialLinearScale";
import {
  Chart as ChartJS,
  PointElement,
  RadialLinearScale,
  Filler,
  Tooltip,
  LineController,
  LineElement,
} from 'chart.js';
import { Radar } from "react-chartjs-2";
import { isMobile } from 'react-device-detect';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  Filler,
  Tooltip,
  LineController,
  LineElement,
);
ChartJS.register(CustomRadialLinearScale);

const CertifChart = ({ dataLoaded, getLabelsForChart, getDatasForChart, noMarginTop, noPadding, withMaxHeight, type }) => {

  const refContainer = useRef(null)
  const refChart = useRef(null)

  const [viewGraph, setViewGraph] = useState(false)

  const [maxYear, setMaxYear] = useState(1)

  const capitalize = (s) => (s && String(s[0]).toUpperCase() + String(s).slice(1)) || ""

  useEffect(() => {
    if (dataLoaded === true) {
      const observer = new ResizeObserver(entries => {
        for (const entry of entries) {
          let width =  entry.contentRect.width
          let height = entry.contentRect.height
          refChart?.current?.resize()
        }
      })
      observer.observe(refContainer.current)
      return () => {
        observer.disconnect();
      }
    }
  }, [dataLoaded])


  const finalDatas = () => {
    let labels = getLabelsForChart();
    let getDatas = getDatasForChart();
    let datas = getDatas?.datasets
    let datasWithoutPoints = datas?.filter((el) => el.title !== "POINTS")

    let indexesToBeDeleted = []
    labels = labels?.map((label, index) => {
      let total = 0
      datasWithoutPoints?.forEach((data) => {
        total += data?.data[index]
      })
      if (total === 0) {
        indexesToBeDeleted.push(index)
        return false
      } else {
        return label
      }
    })
    indexesToBeDeleted = indexesToBeDeleted.reverse();

    datas?.forEach((data) => {
      indexesToBeDeleted.forEach((i) => {
        data.data.splice(i, 1)
        if (data.title === "POINTS") {
          data.pointBackgroundColor?.splice(i, 1)
        }
      })
    })

    indexesToBeDeleted.forEach((i) => {
      getDatas?.arrFamily?.splice(i, 1)
    })


    labels = labels?.filter((el) => el !== false)

    datas = datas?.filter((el) => {
      let findNonZero = el?.data?.some((el2) => el2 !== 0)
      if (findNonZero) {
        return true
      }
    })

    //on regarde pour lier les lignes
    let removePointsData = datas?.filter((el) => el.title !== "POINTS")
    let sortByFirstLabel = removePointsData?.sort((a, b) => {
      let firstNonZeroForA = a?.data?.findIndex((el) => el !== 0)
      let firstNonZeroForB = b?.data?.findIndex((el) => el !== 0)
      if (firstNonZeroForA > firstNonZeroForB) {
        return 1;
      } else if (firstNonZeroForA < firstNonZeroForB) {
        return -1;
      }
      return 0;
    })

    for (let i=0; i<sortByFirstLabel?.length; i++) {
      if (sortByFirstLabel[i+1]) {
        let firstNonZeroInNext = sortByFirstLabel[i+1]?.data?.findIndex((el) => el !== 0)
        sortByFirstLabel[i].data[firstNonZeroInNext] = sortByFirstLabel[i+1].data[firstNonZeroInNext]
      }
    }

    if (sortByFirstLabel?.length > 0) {
      let dataLength = sortByFirstLabel[0]?.data?.length
      sortByFirstLabel[sortByFirstLabel.length-1].data[0] = sortByFirstLabel[0]?.data[0]
    }


    //on rajoute le dataset de points
    let findPointsDatasets = datas?.find((el) => el.title === "POINTS")
    if (findPointsDatasets) {
      sortByFirstLabel.push(findPointsDatasets)
    }

    let arrForTooltips = []
    let labelsCategories = ['communication','efficacite','leadership']
    labelsCategories.forEach((cat) => {
      let count = getDatas?.arrFamily?.filter((el) => el === cat)?.length
      let firstIndex = getDatas?.arrFamily?.findIndex((el) => el === cat)
      let result = firstIndex + Math.round(count/2)
      arrForTooltips.push(result)
    })

    let arrDataTooltips = []
    let arrRadiusTooltips = []
    labels?.forEach((label) => {
      arrDataTooltips.push(0)
      arrRadiusTooltips.push(0)
    })
    arrForTooltips.forEach((i) => {
      arrDataTooltips[i] = 20
      arrRadiusTooltips[i] = 7
    })


    sortByFirstLabel?.push({
      title : "TOOLTIPS",
      data : arrDataTooltips,
      fill : true,
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      borderWidth : 0,
      pointRadius: arrRadiusTooltips,
      pointBackgroundColor: "#585C5E",
      pointHoverBackgroundColor : "black",
      pointHoverRadius: arrRadiusTooltips,
      pointBorderWidth:0,
      customData : getDatas?.arrFamily,
      //spanGaps : true,
    })


    let returnDatas = {
      labels : labels,
      datasets : sortByFirstLabel,
      allSkillsWithScores : type === "recruiter" ? getDatas?.allSkillsWithScores : [],
    }


    return returnDatas
  }

  var chartpluginsset = [
    {
        afterDatasetDraw: (chart) => {
          chart?.ctx.save()
          let finalImage = {
            src : `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNy41IiBjeT0iNy41IiByPSI3LjUiIGZpbGw9InRyYW5zcGFyZW50Ii8+CjxwYXRoIGQ9Ik04LjI3NDgyIDEwLjQ3NjlDOC4yNzQ4MiAxMC43MTM5IDcuOTI5MyAxMC45NTA4IDcuNTA0NzkgMTAuOTUwOEM3LjA2MDUzIDEwLjk1MDggNi43NDQ2NSAxMC43MTM5IDYuNzQ0NjUgMTAuNDc2OVY2LjcxNTYxQzYuNzQ0NjUgNi40MzkxOSA3LjA2MDU2IDYuMjUxNTcgNy41MDQ3OSA2LjI1MTU3QzcuOTI5MyA2LjI1MTU3IDguMjc0ODIgNi40MzkxOSA4LjI3NDgyIDYuNzE1NjFWMTAuNDc2OVpNNy41MDQ4MSA1LjM0MzRDNy4wNTA2OCA1LjM0MzQgNi42OTUzMSA1LjAwNzc0IDYuNjk1MzEgNC42MzI1N0M2LjY5NTMxIDQuMjU3NDIgNy4wNTA3MSAzLjkzMTY0IDcuNTA0ODEgMy45MzE2NEM3Ljk0OTA3IDMuOTMxNjQgOC4zMDQ1IDQuMjU3NDIgOC4zMDQ1IDQuNjMyNTdDOC4zMDQ1IDUuMDA3NzQgNy45NDkwNCA1LjM0MzQgNy41MDQ4MSA1LjM0MzRaIiBmaWxsPSIjRkZGRkZGIiBmaWxsLW9wYWNpdHk9IjAuOSIvPgo8L3N2Zz4K`
          }
          let findDatasetIndex = chart?.data?.datasets?.findIndex((el) => el.title === "TOOLTIPS")
          let activePoints = chart.getDatasetMeta(findDatasetIndex)?.dataset?._points?.filter((el) => el.options.radius !== 0)
          activePoints.forEach((points) => {
            let displayImg = new Image()
            displayImg.src = finalImage?.src
            chart?.ctx.drawImage(displayImg, points.x-7, points.y-7, 14, 14);
          })
          chart?.ctx?.restore()
       }
    }
  ];

  let varFinalDatas = finalDatas()

  return (
    <Box ref={refContainer} sx={{position:"relative", opacity:1, padding:noPadding ? "O":"0px 10px", aspectRatio:!withMaxHeight&&0.95, display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
      {(varFinalDatas?.labels?.length > 0) &&
        <>
          <Radar
            ref={refChart}
            style={{
              marginTop:noMarginTop?'0px':'-60px',
              paddingBottom : '0px',
              maxHeight: withMaxHeight&&"calc(100vh - 350px)"
            }}
            data={varFinalDatas}
            plugins={chartpluginsset}
            options={{
              devicePixelRatio: 2.5,
              responsive: true,
              maintainAspectRatio: true,
              plugins : {
                legend : {
                  display:false,
                  /*fullSize : true,
                  position:"bottom",
                  onClick: function() {},
                  labels : {
                    padding: 10,
                    boxHeight: 10,
                    generateLabels : function(chart) {
                      let legends = []
                      if (chart?.data?.datasets?.some((el) => el.title === 0)) {
                        legends.push({
                          text : "Année 1",
                          fontColor: "black",
                          strokeStyle : "rgba(255, 81, 6, 1)",
                          lineCap : "butt",
                          lineDash : [6,6],
                          lineJoin : "mitter",
                          fillStyle : "rgba(0,0,0,0)",
                          lineWidth : 2,
                        })
                      }
                      if (chart?.data?.datasets?.some((el) => el.title === 1)) {
                        legends.push({
                          text : "Année 2",
                          fontColor: "black",
                          strokeStyle : "rgba(255, 81, 6, 1)",
                          lineCap : "butt",
                          lineDash : [2,2],
                          lineJoin : "mitter",
                          fillStyle : "rgba(0,0,0,0)",
                          lineWidth : 2,
                        })
                      }
                      if (chart?.data?.datasets?.some((el) => el.title === 2)) {
                        legends.push({
                          text : "Année 3",
                          fontColor: "black",
                          strokeStyle : "rgba(255, 81, 6, 1)",
                          fillStyle : "rgba(0,0,0,0)",
                          lineWidth : 2,
                        })
                      }
                      return legends
                    },
                    color:"black",
                    font: {
                      family : "Circular Std Book",
                      weight : 500,
                      size: 13,
                    },
                  }*/
                },
                tooltip: {
                  enabled: true,
                  backgroundColor : "#EEF0F3",
                  titleColor : "black",
                  titleSpacing : 0,
                  borderColor : 'rgba(0, 0, 0, 0.25)',
                  borderWidth : 1,
                  titleFont: {
                    family : "Circular",
                    weight : 500,
                    size: 12,
                  },
                  bodyFont : {
                    size : 0,
                  },
                  padding : {
                    top : 6,
                    left : 6,
                    right : 6,
                    bottom : 0,
                  },
                  filter: function (tooltipItem, data) {
                    if (tooltipItem?.dataset?.title === "TOOLTIPS") {
                      return true
                    } else {
                      return false
                    }
                  },
                  callbacks : {
                    title : function(context) {
                      if (context[0]) {
                        let find = context[0]?.dataset?.customData[context[0]?.dataIndex]
                        if (find === "efficacite") {
                          return "Éfficacité\nopérationnelle"
                        } if (find === "communication") {
                          return "Innovation et\ncommunication"
                        } if (find === "leadership") {
                          return "Collaboration et\nleadership"
                        } else {
                          return null
                        }
                      } else {
                        return null
                      }
                    },
                    label : function() {
                      return null
                    },
                  },
                },
              },
              hover: {
                //mode: null
              },
              layout : {
                padding:{
                  top : isMobile? 80 : 120,
                  bottom : isMobile? 80 : 120,
                  left : isMobile? 70 : 110,
                  right : isMobile? 70 : 110,
                },
              },
              scales: {
                r: {
                  customData : {
                    allSkillsWithScores : varFinalDatas?.allSkillsWithScores,
                  },
                  type: "derivedRadialLinearScale",
                  pointLabels: {
                    display: false,
                    font: {
                      family : "Circular",
                      weight : 500,
                      size: isMobile ? 11 : 13,
                    },
                    color : "rgba(0,0,0,0.6)",
                    callback : function(labelText){
                      return capitalize(labelText)
                    },
                  },
                  backgroundColor : "rgba(255,255,255,0.2)",
                  ticks : {
                    display: false,
                    stepSize: 20,
                  },
                  min: 0,
                  max: 100
                }
              }
            }}
          />
        </>
      }
    </Box>
  )
}


export default CertifChart
